<!-- <h2 class="content-block dx-theme-background-color-as-text-color">{{ languageService.get('reports') }}</h2> -->

<dx-splitter id="splitter responsive-paddings">
  <dxi-item [resizable]="true" size="22%" template="Left Pane">
    <!-- <div width="25%"> -->
    <h3 class="responsive-paddings dx-theme-background-color-as-text-color">{{ languageService.get("report_categories") }}</h3>
    @if (nodes?.length) {
      <div class="content-block dx-card">
        <br/>
        <dx-tree-view
          #reportTreeView
          class="dx-theme-accent-as-text-color"
          [items]="reportTreeStructure"
          itemTemplate="reportTemplate"
          [activeStateEnabled]="true"
          [focusStateEnabled]="false"
          [hoverStateEnabled]="true"
          selectionMode="single"
          [selectByClick]="true"
          (onItemClick)="selectReportCategory($event)"
          (onContentReady)="treeContentReady($event)"
          collapseIcon="activefolder"
          expandIcon="inactivefolder"
          >
          <div *dxTemplate="let item of 'reportTemplate'">
            @if (!item.leaf) {
              <!-- <h4 class="report-title">{{ item.text }}</h4> -->
              <span class="report-title">{{ item.text }}</span>
            }
            @if (item.leaf) {
              <span class="reportcategory-item">{{ item.text }}</span>
            }
          </div>
        </dx-tree-view>
        <br/>
      </div>
    }

  <!-- </div> -->

</dxi-item>
<dxi-item [resizable]="true" [collapsible]="false" size="78%" template="Right Pane">
  <!-- <div width="75%"> -->
  <h3 class="responsive-paddings dx-theme-background-color-as-text-color">{{ languageService.get("report_list") }}</h3>
  <!-- <div class="selected-container"> -->
  @if (nodes?.length) {
    <dx-list
      id="selected-reports"
      [items]="currentItems"
      selectionMode="single"
      (onItemClick)="reportSelected($event)"
      >
      @for (item of currentItems; track item) {
        <dxi-item>
          <div class="dx-card responsive-paddings dx-theme-accent-as-text-color">
            <span class="report-title">{{ item.text }}</span>
            @if (item.description) {
              <p>{{ item.description }}</p>
            }
            <p class="reportcategory-item">{{ item.modifiedAt | date : 'longDate' : undefined : languageService.language }}</p>
          </div>
        </dxi-item>
      }
    </dx-list>
  <!-- </div> -->
}

<!-- </div> -->
</dxi-item>
</dx-splitter>

@if (!nodes?.length) {
  <div class="content-block dx-card responsive-paddings">
    <p>{{ languageService.get('no_report_found') }}</p>
  </div>
}